export default __webpack_public_path__ + "static/media/drops.caba41ca.webp";